import React, { useCallback, useEffect, useState } from 'react';
import Intro from './Intro';
import Hero from './Hero';
import About from './About';
import Footer from './Footer';
import useReveal from './hooks/useReveal';
import { prefersReducedMotion } from './util/motion';

function introAlreadySeen() {
    try {
        return sessionStorage.getItem('rr-animated') === 'true';
    } catch {
        return false; // private mode / storage disabled
    }
}

export default function App() {
    const [introDone, setIntroDone] = useState(
        () => introAlreadySeen() || prefersReducedMotion()
    );

    const finishIntro = useCallback(() => {
        try {
            sessionStorage.setItem('rr-animated', 'true');
        } catch {
            /* nothing to do */
        }
        setIntroDone(true);
    }, []);

    // Keep the page from scrolling underneath the intro card.
    useEffect(() => {
        document.body.style.overflow = introDone ? '' : 'hidden';
        return () => { document.body.style.overflow = ''; };
    }, [introDone]);

    // Flag that JS is running, so the reveal styles can safely hide content.
    useEffect(() => {
        document.documentElement.classList.add('js-reveal');
    }, []);

    useReveal(introDone);

    return (
        <div className="bg-white min-h-screen">
            {!introDone && <Intro onDone={finishIntro} />}
            {/* Rendered underneath the intro card from the start, so fading
                the card out reveals it rather than fading it in afterwards. */}
            <main>
                <Hero />
                <About />
                <Footer />
            </main>
        </div>
    );
}
